module.exports = __webpack_public_path__ + "media/images/iconSquadBet__plus-a4b5df2ba44605cfca81fc4dcc0b12d0.png";